import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Storage } from "@ionic/storage";
import { DataService } from "./data.service";

@Injectable()

export class UnitSearchHistoryService {

  limit = 10;

  constructor(
    public api: ApiService,
    public dataService: DataService,
    public storage: Storage
  ) {}

  public setRecord(record){
    let data = [record];
    return this.setRecords(data);
  }

  public setRecords(data){
    // Set workorder
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('unit_search_history_' + user_id).then((val) => {
          // if local storage already exists
          let unit_history_records = (val ? JSON.parse(val) : []);
          for(let i = 0; i < data.length; i++){
            let record = data[i];
            // Set app_version_number
            record.app_version_number = this.dataService.getAppVersionNumber();
            // Set time_created
            record._time_updated = new Date().getTime();
            // Set id
            if(!record._id) record._id = record.unit_id;
            // Add or update
            let found = false;
            for(let j = 0; j < unit_history_records.length; j++){
              if(unit_history_records[j]._id === record._id){
                found = true;
                // Overwrite record
                unit_history_records[j] = record;
              }
            }
            if(!found){
              // Add record
              unit_history_records.push(record);
            }
          }
          // Limit
          while(unit_history_records.length > this.limit){
            unit_history_records.shift();
          }
          // Save
          this.storage.set('unit_search_history_' + user_id, JSON.stringify(unit_history_records)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        }).catch(() => {
          // if local storage does not exist yet
          let unit_history_records = data;
          this.storage.set('unit_search_history_' + user_id, JSON.stringify(unit_history_records)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public deleteRecord(id){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('unit_search_history_' + user_id).then((val) => {
          let unit_history_records = (val ? JSON.parse(val) : []);
          let found = false;
          for(let j = 0; j < unit_history_records.length; j++){
            if(unit_history_records[j]._id == id){
              found = true;
              unit_history_records.splice(j, 1);
            }
          }
          if(found){
            this.storage.set('unit_search_history_' + user_id, JSON.stringify(unit_history_records)).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public deleteRecords(data){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('unit_search_history_' + user_id).then((val) => {
          let unit_history_records = (val ? JSON.parse(val) : []);
          let changed = false;
          for(let i = 0; i < data.length; i++) {
            let record = data[i];
            for(let j = 0; j < unit_history_records.length; j++){
              if(unit_history_records[j]._id == record._id){
                changed = true;
                unit_history_records.splice(j, 1);
              }
            }
          }
          if(changed){
            this.storage.set('unit_search_history_' + user_id, JSON.stringify(unit_history_records)).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public getAll(){
    return new Promise((resolve) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('unit_search_history_' + user_id).then((val) => {
          let unit_history_records = (val ? JSON.parse(val) : []);
          resolve(unit_history_records);
        }).catch(() => {
          resolve([]);
        });
      }).catch(() => {
        resolve([]);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/unit-search-history.service.ts